
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({ inheritAttrs: false })
export default class PiTable extends Vue {
  // delegate common BTable methods to the inner table
  public refresh(): void {
    (this.$refs.inner as any)?.refresh();
  }
  public clearSelected(): void {
    (this.$refs.inner as any)?.clearSelected();
  }
}
